// src/hooks/cities/useDeleteAllCities.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllCities } from "../../api/apiCities";
import parseError from "../../utils/parseError";

const useDeleteAllCities = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAllCitiesMutate, isPending } = useMutation({
        mutationFn: deleteAllCities,
        onSuccess: (res) => {
            const message = res?.message || "Cities deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["cities"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete cities");
        },
    });

    return { deleteAllCitiesMutate, isPending };
};

export default useDeleteAllCities;